import { UserDetailLayout } from '@layouts/user/UserDetailLayout'
import UserMembershipLayout from '@layouts/membership/UserMembershipLayout'
import ActivitiesTab from '@pages/user/detail/ActivitiesTab'
import AnalyticsTab from '@pages/user/detail/AnalyticsTab'
import InformationsTab from '@pages/user/detail/InformationsTab'
import LegalsTab from '@pages/user/detail/LegalsTab'
import ThirdPartiesTab from '@pages/user/detail/ThirdPartiesTab'
import TransactionsTab from '@pages/user/detail/TransactionsTab'
import { membershipProfileSectionRoutes } from '../membership/MembershipProfileSectionRoutes'
import { Navigate, RouteObject } from 'react-router-dom'

const userDetailRoutes: RouteObject[] = [
  {
    element: <UserDetailLayout />,
    children: [
      { path: 'informations', element: <InformationsTab /> },
      { path: 'transactions', element: <TransactionsTab /> },
      { path: 'analytics', element: <AnalyticsTab /> },
      {
        path: 'membership',
        element: <UserMembershipLayout />,
        children: membershipProfileSectionRoutes,
      },
      { path: 'third-parties', element: <ThirdPartiesTab /> },
      { path: 'activities', element: <ActivitiesTab /> },
      { path: 'legals', element: <LegalsTab /> },

      { index: true, element: <Navigate to="informations" replace /> },
      { path: '*', element: <Navigate to="informations" replace /> },
    ],
  },
]

export default userDetailRoutes
